const errorSubtle2 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="0" d="m12.06 11-7-7L4 5.06l7 7z"/></svg>',
};

export { errorSubtle2 as default };
